module.exports = __webpack_public_path__ + "img/sync.704eefac.svg";